<template>
    <b-container fluid class="h-100 d-flex">

        <b-card bg-variant="light" class="m-auto" style="width: 400px;">
            <b-form name="form" @submit.prevent="handleLogin">
                <b-form-group label="Username" label-for="username">
                    <b-form-input id="username" name="username" v-model="user.username" type="text"
                                  v-validate="'required'" :state="validateState('username')"></b-form-input>
                    <b-form-invalid-feedback id="usernameFeedback'">
                        Username is required.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Password" label-for="password">
                    <b-form-input id="password" name="password" v-model="user.password" type="password"
                                  v-validate="'required'" :state="validateState('password')"></b-form-input>
                    <b-form-invalid-feedback id="passwordFeedback'">
                        Password is required.
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-button type="submit" variant="primary" block :disabled="loading">
                    <b-spinner v-if="loading" small></b-spinner>
                    <span> Login</span>
                </b-button>

                <b-alert :show="message != null" class="mt-3" variant="danger" fade dismissible>
                    {{ message }}
                </b-alert>
            </b-form>
        </b-card>
    </b-container>
</template>

<script>
    import User from '../models/user';

    export default {
        name: "Login",
        data() {
            return {
                user: new User('', ''),
                loading: false,
                message: null
            };
        },
        computed: {
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            }
        },
        created() {
            if (this.loggedIn) {
                this.$router.push('/configuration');
            } else {
                if (this.$appSettings.trustZone) {
                    this.$store.dispatch('auth/retrieveUser').then(
                        () => {
                            this.$router.push({name: "ConfMyPortals", params: { areMyPortal: true }});
                        },
                        error => {
                            this.loading = false;
                            this.message = error.response.data.message;
                        }
                    );
                }
            }
        },
        methods: {
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return this.veeErrors.has(ref) ? !this.veeErrors.has(ref) : null;
                }
                return null;
            },
            handleLogin() {
                this.loading = true;
                this.$validator.validateAll().then(isValid => {
                    if (!isValid) {
                        this.loading = false;
                        return;
                    }

                    if (this.user.username && this.user.password) {
                        this.$store.dispatch('auth/login', this.user).then(
                            () => {
                                this.$router.push({name: "ConfMyPortals", params: { areMyPortal: true }});
                            },
                            error => {
                                this.loading = false;
                                this.message = error.response.data.message;
                            }
                        );
                    }
                });
            },
            getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
            }
        }
    }
</script>

<style>
    body, html {
        height: 100%;
    }
</style>